/* eslint-disable camelcase */
const productImage = {
  create({
    image_url,
    brand,
    external_id,
    description,
    site_url,
  }) {
    /** This method parses data (like a collateral with metadata) into the proper structure to save as a ProductImage. */
    if (!image_url) {
      console.log('image_url is required!');
    }
    return {
      content_type: 'image/jpeg',
      image_url,
      product: {
        brand: {
          name: brand ?? '',
        },
        external_id: external_id ?? -1, // This field can't be null. Bakcend will throw an error if it is.
        images: [
          {
            image_url,
          },
        ],
        price: 0,
        site_url: site_url ?? '',
        title: description ?? '',
      },
      site_url: site_url ?? '',
    };
  },
};

export default productImage;
